// Generated file : do not modify
import GraphQuestion from '@/extend/classes/GraphQuestion';
import GraphGrid from '@/extend/classes/GraphGrid';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Modélisations des conventions
export class ConventionMetiers {
  // Convention
  public convention: string;
  // 
  public conventionId: number;
  // Métiers
  public metiers: Metier[];

  constructor() {
    this.convention = '';
    this.conventionId = 0;
    this.metiers = [];
  }
}

export class Metier {
  // Métier
  public metier: string;
  // 
  public metierId: number;

  constructor() {
    this.metier = '';
    this.metierId = 0;
  }
}

export default class Graph  {
  // Identifiant unique
  public id: number;
  // Convention
  public convention: string;
  // Document d'aide associé
  public url: string;
  // Convention
  public conventionId: number;
  // Questions pour import
  public questions: GraphQuestion[];
  // Grilles des solutions
  public grilles: GraphGrid[];
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.convention = '';
    this.url = '';
    this.conventionId = 0;
    this.questions = [];
    this.grilles = [];
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Graph): Graph {
    const newGraph: Graph = new Graph();
    newGraph.id = obj.id;
    newGraph.convention = obj.convention;
    newGraph.url = obj.url;
    newGraph.conventionId = obj.conventionId;
    newGraph.questions = JSON.parse(JSON.stringify(obj.questions));
    newGraph.grilles = JSON.parse(JSON.stringify(obj.grilles));
    newGraph.canUpdate = obj.canUpdate;
    newGraph.canDelete = obj.canDelete;
    newGraph.display = obj.display;
    newGraph.notifDefType = obj.notifDefType;
    return newGraph;
  }

  public toJsonGraph (): string {
    const json = {
      convention: this.convention,
      url: this.url,
      conventionId: this.conventionId,
      questions: this.questions,
      grilles: this.grilles,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromGraph (obj: Graph): void {
    this.id = obj.id;
    this.convention = obj.convention;
    this.url = obj.url;
    this.conventionId = obj.conventionId;
    this.questions = obj.questions;
    this.grilles = obj.grilles;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareGraph (value: Graph): boolean {
    return (this.toJsonGraph() == value.toJsonGraph());
  }

  public cloneGraph (): Graph {
    return Graph.fromJson(this);
  }

  public static listConventionMetiers (): Promise<ConventionMetiers[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/graphs/listConventionMetiers', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: ConventionMetiers[] = [];
              res.data.forEach(( a: ConventionMetiers ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(graphs: Graph[]) {
  }
}
